var _defs, _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPractice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Category Practice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6de2e2;}.cls-2{fill:#282d3d;}.cls-3{fill:#c4c5ca;}.cls-4{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.5,
    y: 21.5,
    width: 97,
    height: 66,
    rx: 4.19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.31,89H5.69A5.69,5.69,0,0,1,0,83.31V25.69A5.69,5.69,0,0,1,5.69,20H94.31A5.69,5.69,0,0,1,100,25.69V83.31A5.69,5.69,0,0,1,94.31,89ZM5.69,23A2.7,2.7,0,0,0,3,25.69V83.31A2.7,2.7,0,0,0,5.69,86H94.31A2.7,2.7,0,0,0,97,83.31V25.69A2.7,2.7,0,0,0,94.31,23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66,23H34V8H66ZM37,20H63V11H37Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59,44H41V20H59ZM44,41H56V23H44Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48,
    y: 29,
    width: 4,
    height: 8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37,
    y: 11,
    width: 26,
    height: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5,
    y: 89,
    width: 90,
    height: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2,
    y: 38,
    width: 39.5,
    height: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 59,
    y: 38,
    width: 38.5,
    height: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.58,76.5A12.07,12.07,0,0,1,61,67.5H39.21a12.07,12.07,0,0,1-11.61,9,11.8,11.8,0,0,1-10.36-6.07,2,2,0,0,1,0-2,2,2,0,0,1,1.75-1h8.59a2.94,2.94,0,0,0,2.94-2.94v-.12a2.94,2.94,0,0,0-2.94-2.94H18.94a1.91,1.91,0,0,1-1.72-2.9A11.8,11.8,0,0,1,27.6,52.5a12.07,12.07,0,0,1,11.61,9H61a12.07,12.07,0,0,1,11.61-9,11.84,11.84,0,0,1,10.2,5.78A2.05,2.05,0,0,1,81,61.5H72.5a3,3,0,0,0,0,6h8.55a2,2,0,0,1,1.77,3.14A11.8,11.8,0,0,1,72.58,76.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.58,76.5A12.07,12.07,0,0,1,61,67.5H39.21a12.07,12.07,0,0,1-11.61,9,11.8,11.8,0,0,1-10.36-6.07,2,2,0,0,1,0-2,2,2,0,0,1,1.75-1h8.59a2.94,2.94,0,0,0,2.94-2.94v-.12a2.94,2.94,0,0,0-2.94-2.94H18.94a1.91,1.91,0,0,1-1.72-2.9A11.8,11.8,0,0,1,27.6,52.5a12.07,12.07,0,0,1,11.61,9H61a12.07,12.07,0,0,1,11.61-9,11.84,11.84,0,0,1,10.2,5.78A2.05,2.05,0,0,1,81,61.5H72.5a3,3,0,0,0,0,6h8.55a2,2,0,0,1,1.77,3.14A11.8,11.8,0,0,1,72.58,76.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.58,54a10.35,10.35,0,0,1,8.91,5.06c.32.52.09.94-.52.94H72.5a4.5,4.5,0,0,0,0,9h8.55c.56,0,.77.39.48.88a10.37,10.37,0,0,1-9,5.12A10.49,10.49,0,0,1,62.2,66H38A10.49,10.49,0,0,1,27.6,75a10.37,10.37,0,0,1-9-5.31c-.22-.37,0-.69.42-.69h8.59A4.46,4.46,0,0,0,32,64.56v-.12A4.46,4.46,0,0,0,27.56,60H18.94c-.42,0-.61-.31-.41-.67A10.44,10.44,0,0,1,38,63H62.2a10.49,10.49,0,0,1,10.38-9m0-3a13.56,13.56,0,0,0-12.71,9H40.32a13.44,13.44,0,0,0-24.4-2.14,3.41,3.41,0,0,0,3,5.14h8.62A1.46,1.46,0,0,1,29,64.44v.12A1.46,1.46,0,0,1,27.56,66H19a3.42,3.42,0,0,0-3,5.17A13.43,13.43,0,0,0,27.6,78a13.57,13.57,0,0,0,12.72-9H59.87a13.56,13.56,0,0,0,12.71,9,13.3,13.3,0,0,0,11.53-6.59A3.5,3.5,0,0,0,81.05,66H72.5a1.5,1.5,0,0,1,0-3H81a3.54,3.54,0,0,0,3.09-5.49A13.3,13.3,0,0,0,72.58,51Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPractice);
export default __webpack_public_path__ + "static/media/practice.38267ba0.svg";
export { ForwardRef as ReactComponent };